<template>
  <div class="animated fadeIn">
    <i
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <v-btn elevation="6" outlined small>A</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          نمایش تمامی محصولات<br /><br />
          <v-btn elevation="6" outlined small>R</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          پاک کردن جستجو<br /><br />
          <!-- <v-btn elevation="6" outlined small>n</v-btn> ساخت آیتم جدید -->

          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <v-col lg="12" class="ml-auto"></v-col>

    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h5 class="m-0 pt-1">جستجوی دقیق محصولات</h5>
      </template>
      <loading v-if="vLoading" />
      <b-card>
        <h5>لطفا المان‌های مورد نیاز برای جستجو را پر کنید و جستجو کنید.</h5>
        <h6>
          <i class="mx-1 fa fa-exclamation-triangle text-dark"></i>توجه: جستجو
          به حروف کوچک و بزرگ و علائم مثل نقطه و - حساس است.
        </h6>
        <h6>
          <i class="mx-1 fa fa-exclamation-triangle text-dark"></i>توجه: جستجو
          به صورت دقیق انجام میشود. برای جستجوی تقریبی به صفحه
          <a
            href="/warehouse/productsSearch"
            target="_blank"
            rel="noopener noreferrer"
          >
            جستجوی تقریبی</a
          >
          مراجعه فرمایید.
        </h6>
        <v-row>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              label="شرح فارسی"
              v-model="searchTerms.identifierFa"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="شرح انگلیسی"
              v-model="searchTerms.identifierEn"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام"
              v-model="searchTerms.name"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="searchTerms.material"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="searchTerms.coating"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="searchTerms.dimensionStandard"
              @keyup.enter="doSearch()"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="searchTerms.diameter"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="طول"
              v-model="searchTerms.length"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="واحد اندازه‌گیری"
              v-model="searchTerms.measurementUnit"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="توضیحات"
              v-model="searchTerms.description"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="کد قدیم"
              v-model="searchTerms.oldId"
              @keyup.enter="doSearch()"
            ></v-text-field>
            <!-- <v-text-field
              outlined
              dense
              label="توضیحات فنی"
              v-model="searchTerms.technicalDescription"
            ></v-text-field> -->
            <v-btn
              style="float: left"
              class="text-white mx-1"
              color="success"
              @click="doSearch()"
            >
              جستجو
            </v-btn>
            <v-btn
              style="float: left"
              class="text-white mx-1"
              color="warning"
              @click="searchTerms = {}"
              v-shortkey.once="['ctrl' + 'r']"
              @shortkey="searchTerms = {}"
            >
              پاک کردن جستجو
            </v-btn>
            <v-btn
              style="float: left"
              class="text-white mx-1"
              color="red"
              @click="showAll()"
              v-shortkey.once="['ctrl' + 'a']"
              @shortkey="showAll()"
            >
              نمایش تمامی محصولات
            </v-btn>
          </v-col>
        </v-row>
      </b-card>
      <br />
      <b-card class="shadow p-3 mb-5 bc-white rounded" v-if="searchDone">
        <h6>تعداد کل نتایج جستجو: {{ items.length }}</h6>
        <h6>تعداد نتایج زیر: {{ filtered.length }}</h6>
        <b-table
          responsive
          show-empty
          id="itemsTable"
          :items="filtered"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="filter"
          class="table-filter"
          @filtered="onFiltered"
        >
          <template slot="top-row">
            <td v-for="field in fields" :key="field.key">
              <b-form-input
                v-if="field.key != 'index' && field.key != 'operation'"
                v-model="filters[field.key]"
                :placeholder="field.label"
              ></b-form-input>
            </td>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle" dir="ltr">
              {{ data.value }}
            </div>
          </template>

          <template v-slot:cell(operation)="row">
            <b-button
              class="mr-1"
              variant="primary"
              @click="openDetailDialog(row.item)"
              >جزییات
            </b-button>
            <!-- <b-button
              class="mr-1"
              variant="success"
              @click="openEditDialog(row.item)"
              >ویرایش
            </b-button> -->
            <b-button
              v-if="
                role == 'Manager' ||
                role == 'ceo' ||
                role == 'factory' ||
                role == 'productsWarehouse'
              "
              class="mr-1"
              variant="warning"
              @click="openChangeInventoryDialog(row.item)"
              >رسید / حواله
            </b-button>
          </template>

          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <template v-slot:cell(name)="data">
            <div
              v-if="
                role == 'Manager' ||
                role == 'ceo' ||
                role == 'factory' ||
                role == 'productsWarehouse'
              "
              style="text-align: center; vertical-align: middle"
            >
              <a
                :href="'/warehouse/' + type.slug + '/' + data.item.id"
                target="_blank"
                >{{ data.value }}</a
              >
            </div>
            <div v-else style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(identifierEn)="data">
            <div style="text-align: center; vertical-align: middle">
              <a
                :href="'/warehouse/' + type.slug + '/' + data.item.id"
                target="_blank"
                >{{ data.value }}</a
              >
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="filtered.length"
          :per-page="perPage"
          aria-controls="itemsTable"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
    </b-card>
    <v-dialog v-model="changeInventoryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="changeInventory-btn mt-3">
            <v-btn color="success" class="mb-4" @click="openEntryDialog()"
              >رسید - افزایش موجودی</v-btn
            >
            <v-btn color="red" class="text-light mb-4" @click="openExitDialog()"
              >حواله – کاهش موجودی</v-btn
            >
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="entryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>رسید - افزایش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ ورود">
              <date-picker v-model="entry.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group label="ساعت ورود">
              <date-picker
                v-model="entry.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <!-- <v-select
              label="انبار مقصد"
              :items="warehouses"
              v-model="entry.warehouse"
              outlined
              dense
              item-text="name"
              item-value="id"
            /> -->
            <v-autocomplete
              label="انبار مقصد"
              v-model="entry.warehouse"
              :items="warehouses"
              outlined
              dense
              item-text="name"
              item-value="id"
            >
            </v-autocomplete>
            <v-text-field
              outlined
              dense
              label="حجم ورودی"
              v-model="entry.number"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مبدا"
              v-model="entry.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="entry.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="entryDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="entrySubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exitDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>حواله - کاهش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ خروج">
              <date-picker v-model="exit.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group label="ساعت ورود">
              <date-picker
                v-model="exit.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <!-- <v-select
              label="انبار مبدا"
              :items="warehouses"
              v-model="exit.warehouse"
              outlined
              dense
              item-text="name"
              item-value="id"
            /> -->
            <v-autocomplete
              label="انبار مبدا"
              v-model="exit.warehouse"
              :items="warehouses"
              outlined
              dense
              item-text="name"
              item-value="id"
            >
            </v-autocomplete>
            <v-text-field
              outlined
              dense
              label="حجم خروجی"
              v-model="exit.number"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مقصد"
              v-model="exit.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="exit.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="exitDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="exitSubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="شرح فارسی *"
              v-model="selected2.identifierFa"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="شرح انگلیسی *"
              dir="ltr"
              v-model="selected2.identifierEn"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام"
              v-model="selected2.name"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="selected2.material"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="selected2.coating"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="selected2.dimensionStandard"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="selected2.diameter"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="selected2.length"
            ></v-text-field>

            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="selected2.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeEditModal()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="editItem()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>جزییات</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container
            v-if="
              role == 'Manager' ||
              role == 'ceo' ||
              role == 'factory' ||
              role == 'productsWarehouse'
            "
            class="mt-3"
          >
            <br />
            <table width="100%" border="1px" v-if="!isBusy2">
              <tbody>
                <tr v-for="field in fieldsFull" :key="field.key">
                  <td style="text-align: center">
                    <strong>{{ field.label }}</strong>
                  </td>
                  <td style="text-align: center">{{ info[field.key] }}</td>
                </tr>
              </tbody>
            </table>

            <b-table
              responsive
              show-empty
              id="detailsTable"
              :items="info.allExchanges"
              :fields="exchangesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPageExchanges"
              :per-page="perPage"
              :busy="isBusy2"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPageExchanges - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="currentPageExchanges"
              :total-rows="info.allExchanges ? info.allExchanges.length : 0"
              :per-page="perPage"
              aria-controls="detailsTable"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
            <br />
          </v-container>
          <v-container v-else-if="isBusy2" class="text-center">
            لطفا چند لحظه صبر کنید...
            <b-spinner> </b-spinner>
          </v-container>
          <v-container v-else>
            <table width="100%" border="1px" v-if="!isBusy2">
              <tbody>
                <tr v-for="field in fieldsFull" :key="field.key">
                  <td style="text-align: center">
                    <strong>{{ field.label }}</strong>
                  </td>
                  <td style="text-align: center">{{ info[field.key] }}</td>
                </tr>
              </tbody>
            </table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data: function () {
    return {
      guide: false,
      role: "",
      searchDone: false,
      searchTerms: {},
      type: Var.allTypes[0],
      items: [],
      warehouses: [],
      changeInventoryDialog: false,
      entryDialog: false,
      exitDialog: false,
      transferDialog: false,
      editDialog: false,
      detailDialog: false,
      adFilter: {},
      filters: {},
      info: [],
      selected: "",
      selected2: [],
      entry: {},
      exit: {},
      transfer: {},
      edit: {},
      moment: moment,
      filterOpt: [
        { key: "all", label: "همه" },
        { key: "exist", label: "اقلام دارای موجودی" },
        { key: "none", label: "اقلام بدون موجودی" },
      ],
      filter: null,
      fields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "sum", label: "موجودی" },
        // { key: "index", label: "ردیف" },
        // { key: "identifierFa", label: "شرح فارسی" },
        // { key: "identifierEn", label: "شرح انگلیسی" },
        // { key: "inventory", label: "موجودی" },

        { key: "operation", label: "عملیات" },
      ],
      fieldsFull: [
        { key: "identifierFa", label: "شرح فارسی" },
        { key: "identifierEn", label: "شرح انگلیسی" },
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "sum", label: "موجودی" },
        { key: "measurementUnit", label: "واحد اندازه‌گیری" },
        { key: "description", label: "توضیحات" },
        { key: "technicalDescription", label: "توضیحات فنی" },
        { key: "alertRange", label: "بازه اخطار" },
        { key: "crisisRange", label: "بازه بحران" },
        { key: "expireDate", label: "تاریخ انقضا" },
      ],
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "note", label: "توضیحات" },
        { key: "warehouseName", label: "انبار مربوطه" },
        { key: "date", label: "تاریخ" },
      ],
      currentPage: 1,
      currentPageExchanges: 1,
      perPage: 10,
      isBusy: false,
      isBusy2: false,
      TotalRows: 1,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    showAll() {
      var tempSearchTerms = this.searchTerms;
      this.searchTerms = {};
      this.doSearch();
      this.searchTerms = tempSearchTerms;
    },
    doSearch() {
      this.vLoading = true;
      this.searchDone = false;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItems/filter",
        // "http://localhost:3002/ppkpms/warehouse/warehouseItems/filter",
        {
          warehouseTypeId: this.type.id,
          material: this.searchTerms.material,
          coating: this.searchTerms.coating,
          dimensionStandard: this.searchTerms.dimensionStandard,
          diameter: this.searchTerms.diameter,
          length: this.searchTerms.length,
          description: this.searchTerms.description,
          measurementUnit: this.searchTerms.measurementUnit,
          identifierFa: this.searchTerms.identifierFa,
          identifierEn: this.searchTerms.identifierEn,
          name: this.searchTerms.name,
          oldId: this.searchTerms.oldId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.items = res.data;
            this.items.sort((a, b) => (a.name < b.name ? 1 : -1));
            this.items.forEach((service) => {
              if (service.sum) {
                service._rowVariant = "primary";
              } else {
                service._rowVariant = "secondary ";
              }
            });
            if (this.items.length) this.searchDone = true;
            else this.toast("جستجو نتیجه‌ای نداشت", "warning");
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    openChangeInventoryDialog(item) {
      this.changeInventoryDialog = true;
      this.selected = item;
    },
    openEntryDialog() {
      this.entryDialog = true;
      this.entry = {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        time: moment(new Date()).format("HH:mm"),
      };
    },
    openExitDialog() {
      this.exitDialog = true;
      this.exit = {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        time: moment(new Date()).format("HH:mm"),
      };
    },
    openTransferDialog() {
      this.transferDialog = true;
      this.transfer.to = "";
    },
    openEditDialog(item) {
      this.editDialog = true;
      this.selected2 = JSON.parse(JSON.stringify(item));
    },
    closeEditModal() {
      this.editDialog = false;
    },
    openDetailDialog(item) {
      this.info = {};
      this.detailDialog = true;
      this.selected = item.id;
      this.getInfo();
    },
    getInfo() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/getInfo",
        {
          warehouseItemId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 200) {
            this.info = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy2 = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    entrySubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/entranceProduct",
        {
          warehouseItemId: this.selected.id,
          warehouseSectionId: this.entry.warehouse,
          amount: this.entry.number,
          date: this.entry.date + " " + this.entry.time,
          orgDes: this.entry.origin,
          note: this.entry.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.entryDialog = false;
            this.entry = {};
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/exitProduct",
        {
          warehouseItemId: this.selected.id,
          warehouseSectionId: this.exit.warehouse,
          amount: this.exit.number,
          date: this.exit.date + " " + this.exit.time,
          orgDes: this.exit.origin,
          note: this.exit.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.exitDialog = false;
            this.exit = {};
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    editItem() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.selected2.id,
          name: this.selected2.name,
          identifierFa: this.selected2.identifierFa,
          identifierEn: this.selected2.identifierEn,
          description: this.selected2.description,
          technicalDescription: this.selected2.technicalDescription,
          material: this.selected2.material,
          coating: this.selected2.coating,
          dimensionStandard: this.selected2.dimensionStandard,
          diameter: this.selected2.diameter,
          length: this.selected2.length,
          place: this.selected2.place,
          suppliersList: this.selected2.suppliersList,
          expireDate: this.selected2.expireDate,
          measurementUnit: this.selected2.measurementUnit,
          alertRange: this.selected2.alertRange,
          crisisRange: this.selected2.crisisRange,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getWarehouses() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseSections/getAll",
        {
          warehouseTypeId: this.type.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.warehouses = res.data;
            this.warehouses = this.warehouses.sort((a, b) =>
              a.name > b.name ? 1 : -1
            );
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },
  computed: {
    filtered() {
      var filtered;
      if (this.items.length) {
        filtered = this.items.filter((item) => {
          return Object.keys(this.filters).every((key) =>
            String(item[key])
              .toLowerCase()
              .includes(this.filters[key].toLowerCase())
          );
        });
      } else filtered = [];
      return filtered;
    },
  },

  mounted() {
    this.role = window.localStorage.getItem("role");
    this.getWarehouses();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
.changeInventory-btn {
  display: flex;
  align-items: center;
  flex-flow: column;
}
/* .table-filter tbody tr {
  background-color: #f2f2f2 !important;
} */
</style>
